import {createContext} from "react";
import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {removeListingParams} from "../../listing-params";

const {Provider, Consumer} = createContext(null);

export const InternalLinkProvider = Provider;

export const MenuInternalLink = ({to, navBlock=undefined, ...props}) => cs(
    ({}) => InternalLink({
        to,
        navBlock,
        ...props,
    }),
);

export const InternalLink = ({to, navBlock=undefined, onClick = null, ...props}:{
    [prop: string] : any,
    to             ?: string,
    onClick        ?: (e:React.MouseEvent) => boolean | Promise<boolean>,
} & Omit<React.HTMLProps<HTMLAnchorElement>, "href">) => cs(
    consumeContext("routerHistory"),
    ["linkAction", ({routerHistory}, next) => <Consumer>{(linkAction) => next(linkAction || routerHistory?.push)}</Consumer>],
    ({routerHistory, linkAction}) => (
        <a
            {...props}
            href={routerHistory?.createHref({pathname:to})}
            onClick={async (e) => {
                e.preventDefault();

                if (await navBlock?.block() === true) {
                    return;
                }

                if (onClick && await onClick(e) === false) {
                    return;
                }

                linkAction(to);

                window.scrollTo(0, 0);
            }}
        />
    ),
);

